'use client';

import { useTranslations } from '@/components/language-provider';
import { useTheme } from '@/components/theme-provider';

function SunIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true" {...props}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v1.5M12 20.5V22M4.22 4.22l1.06 1.06M18.72 18.72l1.06 1.06M2 12h1.5M20.5 12H22M4.22 19.78l1.06-1.06M18.72 5.28l1.06-1.06" />
    </svg>
  );
}

function MoonIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true" {...props}>
      <path d="M21 12.79A9 9 0 0 1 11.21 3c0-.34 0-.67.05-1A9 9 0 1 0 21 12.79" />
    </svg>
  );
}

export function ThemeToggle() {
  const { theme, actualTheme, toggleTheme } = useTheme();
  const { messages } = useTranslations();

  const isDark = actualTheme === 'dark';
  const themeLabel = theme === 'system'
    ? `${messages.toggles.system} (${isDark ? messages.toggles.dark : messages.toggles.light})`
    : isDark
      ? messages.toggles.dark
      : messages.toggles.light;
  const label = `${messages.toggles.theme}: ${themeLabel}`;

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      className="flex items-center gap-2 rounded-full border border-border bg-surface px-3 py-1.5 text-sm font-medium text-foreground shadow-sm transition hover:-translate-y-0.5 hover:shadow-md focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
    >
      <span className="relative flex size-4 items-center justify-center">
        <SunIcon className={`size-4 transition-opacity ${isDark ? 'opacity-0' : 'opacity-100'}`} />
        <MoonIcon className={`absolute size-4 transition-opacity ${isDark ? 'opacity-100' : 'opacity-0'}`} />
      </span>
      <span className="hidden sm:inline">{themeLabel}</span>
    </button>
  );
}
